import React, { useEffect, useCallback } from 'react';
import TrendChartsComponent from './TrendChartsComponent';
import { getTrendKPIsForAssetV2 } from '../../../commonActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import PropTypes from 'prop-types';


const TrendChartsContainer = (props) => {

    const fetchKPIs = useCallback(async () => {
        await props.actions.getTrendKPIsForAssetV2(props.asset);
    }, [props.actions, props.asset]);

    useEffect(() => {
        fetchKPIs();
    }, [fetchKPIs]);

    useEffect(() => {
        // check needed because multi graph KPIs are based on this, to be removed in the future when config comes from BE
        if (props.model.availableKPIs.length) {
            props.actions.getMultiChartConfig(props.model.availableKPIs);
        }
    }, [props.model.availableKPIs]);

    useEffect(() => {
        return () => {
            props.actions.clearMultiChartData();
        };
    }, []);

    return <LoadingStatusWrapper
        indicatorConfig={{ placement: 'sticky' }}
        loadingStatus={props.model.trendKPILoadingStatus}
    >
        {props.model.multiChartPreselection?.length ?
            <TrendChartsComponent {...props} /> : null}
    </LoadingStatusWrapper>;
};

TrendChartsContainer.propTypes = {
    asset: PropTypes.object,
    model: PropTypes.shape({
        availableKPIs: PropTypes.array,
        trendKPILoadingStatus: PropTypes.string,
        multiChartPreselection: PropTypes.array,
    }),
    actions: PropTypes.shape({
        getTrendKPIsForAssetV2: PropTypes.func,
        getMultiChartConfig: PropTypes.func,
        clearMultiChartData: PropTypes.func,
    }),
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, getTrendKPIsForAssetV2 }, dispatch)
    };
};

const TrendChartsContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(TrendChartsContainer);

export default TrendChartsContainerConn;
